import { useTranslation } from "react-i18next";
import Api from "../../../../../constants/Api";
import ListPage from "../../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import { Dropdown } from "react-bootstrap";
import SaveIcon from "../../../Icon/SaveIcon";
import EditIcon from "../../../Icon/EditIcon";
import TrashIcon from "../../../Icon/TrashIcon";
import { useState, useMemo } from "react";
import ModalPage from "../../../Common/Modal/ModalPage";
import AddressNew from "./AddressNew";
import axiosInstance from "../../../../../services/AxiosInstance";
import { errorAlert, successAlert, warnAlert, warnAlertYesOrNo } from "../../../alert/defaultAlert";

const AddressList = (props) => {

    const { t } = useTranslation();
    const [showModalNew, setShowModalNew] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [gridRef, setGridRef] = useState(null);
    const { parentId } = props;
    const [entityId, setEntityId] = useState(null);

    const filters = useMemo(() => [
        {
            field: "parentId",
            value: parentId,
            operation: "EQUAL"
        }
    ], [parentId]);

    const handleNew = () => {
        // Garante um novo cadastro. O id null indica que será 
        // um  novo registro no banco.
        setEntityId(null);
        setShowModalNew(true);
    }

    const handleUpdate = () => {
        if (selectedRows.length === 0) {
            warnAlert(t('validation.required.row'));
            return;
        }

        setEntityId(selectedRows[0].id);
        setShowModalNew(true);
    }

    const handleRemove = () => {
        if (selectedRows.length === 0) {
            warnAlert(t('validation.required.row'));
            return;
        }

        if (gridRef !== null) {
            warnAlertYesOrNo(t('message.remove_the_selected_item'), () => {
                axiosInstance.delete(Api.main.customer_address + "/" + selectedRows[0].id)
                    .then(() => {
                        successAlert(t('message.removed_successfully'));

                        const gridApi = gridRef.current?.api;
                        // O ListPage usa o modelo infinite; nesse modo a transação local
                        // não altera o cache exibido. Recarregamos o bloco e mantemos a
                        // transação apenas como fallback para grids client-side.
                        if (gridApi?.refreshInfiniteCache) {
                            gridApi.refreshInfiniteCache();
                            gridApi.deselectAll();
                        } else {
                            gridApi?.applyTransaction({ remove: selectedRows });
                        }
                    })
                    .catch(error => errorAlert(error))
            });
        } else {
            warnAlert("GridRef not found");
        }
    }

    const customButtons = () => {
        return (
            <>
                <Dropdown.Item onClick={() => handleNew()}><SaveIcon /> {t('new')}</Dropdown.Item>
                <Dropdown.Item onClick={() => handleUpdate()}><EditIcon /> {t('update')}</Dropdown.Item>
                <Dropdown.Item onClick={() => handleRemove()}><TrashIcon /> {t('remove')}</Dropdown.Item>
            </>
        );
    }

    return (
        <>
            <ModalPage
                title={t('address_new')}
                show={showModalNew}
                setShow={setShowModalNew}
                child={<AddressNew setShow={setShowModalNew} parentId={parentId} gridRef={gridRef} entityId={entityId} setEntityId={setEntityId} />}
                size="md"
            />

            <ListPage
                path={Api.main.customer_address}
                columns={Columns}
                height="300px"
                hideDefaultButtons={true}
                customButtons={customButtons()}
                setSelectedRows={setSelectedRows}
                setGridRef={setGridRef}
                filters={filters}
            />
        </>
    );
}

export default AddressList;
